import type {
  MatchServiceAction,
  LoadRelatedAction,
  SelectBillToAction,
  SetSavingAction,
  UnmatchServiceAction,
} from './actions'

export const matchServiceCreator = (
  payload: MatchServiceAction['payload'],
): MatchServiceAction => ({ type: 'matchService', payload })

export const loadRelatedCreator = (
  payload: LoadRelatedAction['payload'],
): LoadRelatedAction => ({ type: 'loadRelated', payload })

export const selectBillToCreator = (
  payload: SelectBillToAction['payload'],
): SelectBillToAction => ({ type: 'selectBillTo', payload })

export const setSavingCreator = (
  payload: SetSavingAction['payload'],
): SetSavingAction => ({ type: 'setSaving', payload })

export const unmatchServiceCreator = (
  payload: UnmatchServiceAction['payload'],
): UnmatchServiceAction => ({ type: 'unmatchService', payload })
